export const experienceData = [
  {
    title: 'Full Stack Developer (React & Java)',
    company: 'Banco Hipotecario',
    period: 'Sep 2025 - Actualidad',
    tasks: [
      'Lidero de forma integral (end-to-end) el desarrollo del módulo de Inversiones de la plataforma bancaria.',
      'Construí desde cero flujos transaccionales complejos para la compra y venta de acciones y bonos.',
      'Desarrollé el motor de operatoria para la compra de Dólar MEP automatizado y participación en licitaciones.',
      'Coordino la integración técnica con servicios core del banco, asegurando escalabilidad y seguridad de datos.',
      'Resuelvo bugs críticos y aplico estrategias de testing para garantizar la alta disponibilidad en producción.',
    ],
  },
  {
    title: 'Software Engineer (React Native & Node.js)',
    company: 'ItRocks',
    period: 'Dic 2024 - Sep 2025',
    tasks: [
      'Lideré el diseño e implementación de la arquitectura base del proyecto mobile en React Native.',
      'Desarrollé e integré funcionalidades clave conectando la app móvil con servicios backend en Node.js.',
      'Optimicé el rendimiento global mediante la reestructuración del estado y reducción de tiempos de carga.',
      'Implementé pruebas automatizadas para maximizar la calidad del código y mitigar errores críticos.',
      'Gestioné el ciclo completo de publicación y actualización en Apple Store y Google Play.',
    ],
  },
  {
    title: 'Software Engineer (React Native & Frontend)',
    company: 'GlobalNews Group',
    period: 'Abril 2023 - Marzo 2025',
    tasks: [
      'Participé en el armado de la arquitectura mobile con componentes reutilizables, acelerando el time-to-market.',
      'Colaboré estrechamente con diseño (UI/UX) y QA para resolver errores y garantizar interfaces fluidas.',
      'Lideré el mantenimiento evolutivo de la plataforma mediante la actualización estratégica de librerías.',
      'Optimicé la estabilidad general del sistema integrando buenas prácticas en diversos dispositivos.',
    ],
  },
  {
    title: 'Full Stack Developer',
    company: 'Magnetico',
    period: 'Jul 2024 - Oct 2024',
    tasks: [
      'Desarrollé un sistema integral de gestión de pedidos utilizando Next.js para frontend y NestJS para backend.',
      'Diseñé e implementé el flujo de asignación automática de órdenes y lógica de cotizaciones personalizadas.',
      'Lideré la integración eficiente de microservicios, asegurando la consistencia y comunicación de los datos.',
    ],
  },
  {
    title: 'Software Engineer (React Native & TypeScript)',
    company: 'IUTRACE',
    period: 'Feb 2020 - Mar 2023',
    tasks: [
      'Evolucioné en el equipo hasta consolidarme como referente técnico, liderando la revisión de Pull Requests.',
      'Diseñé flujos de usuario complejos integrando de manera eficiente servicios REST y GraphQL.',
      'Trabajé en la migración estratégica del código base de JavaScript a TypeScript, reduciendo errores en producción.',
      'Robustecí la documentación interna y expandí la cobertura de pruebas automatizadas con Jest y Detox.',
    ],
  },
];
